<template>
    <div class="firm-index-page">
        <div class="top-card">
            <div class="card-left">
                <firm-info-card/>
            </div>
            <div class="card-right">
                <bind-vip-card
                    @clickBindVip="handleBindVip"
                />
            </div>
        </div>
        <div class="rights-card">
            <privilege-card/>
        </div>
        <!-- 权益对比列表 -->
        <div class="rights-compare">
            <privilege-compare/>
        </div>
        <!-- 绑码弹窗 -->
        <bind-vip-code
            :show="isBind"
            title="绑定百度律所VIP会员"
            :is-firm="1"
            placeholder="请输入律所会员码"
            @closeDialog="closeDialog"
            @openDialog="openDialog"
            @getVipInfo="getVipInfo"
        />
    </div>
</template>
<script>
/**
 * @file firm-index.vue
 * @author zhengyixin
 * @desc 律所会员中心
 */
import BindVipCode from '@/components/bind-vip-code/bind-vip-code';
import {mapState, mapActions} from 'vuex';
import firmInfoCard from '@/components/firm/firm-info-card.vue';
import bindVipCard from '@/components/firm/bind-vip-card.vue';
import privilegeCompare from '../components/privilege-compare.vue';
import privilegeCard from '../components/privilege-card.vue';

export default {
    name: 'firmIndex',
    components: {
        'bind-vip-code': BindVipCode,
        'firm-info-card': firmInfoCard,
        'bind-vip-card': bindVipCard,
        'privilege-compare': privilegeCompare,
        'privilege-card': privilegeCard
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew || {},
            lawBusinessInfo: state => state.lawStore.userInfoNew?.law_business_info || {},
            vipInfo: state => state.lawStore.vipInfo || {}
        })
    },
    data() {
        return {
            isBind: false
        };
    },
    methods: {
        ...mapActions({
            getVipInfo: 'lawStore/getVipInfo'
        }),
        openDialog() {
            this.isBind = true;
        },
        closeDialog() {
            this.isBind = false;
        },
        handleBindVip() {
            this.isBind = true;
        }
    }
};
</script>
<style scoped lang="stylus">
/deep/ .veui-tooltip {
    border-radius: 8px;

    .veui-tooltip-content {
        margin: 24px;
    }
}

.firm-index-page {
    font-family: PingFangSC-Regular;
    line-height: 1;

    .top-card {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .card-left {
            font-size: 18px;

            .title {
                font-family: PingFangSC-Semibold;
                font-size: 42px;
                color: #ffe0b9;
                font-weight: 600;
                margin-bottom: 21px;
            }

            .mt {
                margin-top: 14px;
            }
        }

        .card-right {
            margin-left: 18px;
        }
    }

    .firm-intro {
        display: block;
        width: 100%;
    }

    .rights-compare {
        background: #fff;
        border-radius: 8px;
    }
}
</style>